import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSelector } from "react-redux";
import { apiDelete, apiGet, apiPost } from "api/callApi";
import { DropdownWithSearch } from "InnoUI/innoinput";
import DistributionDropdownWithSearch from "components/DistributionDropdownWithSearch";
import { showAlert } from "utils/helper";

const DistributedListDropdown = forwardRef((props, ref) => {
  const {
    onChange = () => {},
    defaultValue,
    newItemLabel = "",
    name,
    disabledDropdown,
  } = props;
  const [data, setData] = useState([]);

  const currentProject = useSelector(
    (state) => state?.currentProject?.data || null
  );

  const getData = async (successCallback = () => {}) => {
    try {
      const response = await apiGet(
        `/v1/bulkjournal/getlist?projectId=${currentProject.id}`
      );
      setData(response.data);
      successCallback();
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useImperativeHandle(ref, () => ({
    refreshData: () => getData(),
  }));


  const selectOptions =
    data.map((item) => ({
      id: item.id,
      label: item.listName,
    })) || [];

  const handleDropdownChange = (value) => {
    const selectedOption = selectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel, data);
  };

  const handleRemove = async (id) => {
    try {
      const response = await apiPost(`/v1/bulkjournal/deletelist/${id}`);
      getData();
      showAlert({ title: "Success", text: response.message, icon: "success" });
      // onChange(name, "", []);
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <DistributionDropdownWithSearch
      defaultValue={defaultValue}
      placeholder="Select List"
      options={selectOptions}
      onChange={handleDropdownChange}
      borderColor="#E36E00"
      disabled={false}
      newItemLabel={newItemLabel}
      disabledDropdown={disabledDropdown}
      handleRemove={handleRemove}
    />
  );
});

export default DistributedListDropdown;
